module.exports = __webpack_public_path__ + "img/logo.fe667f2f.png";